export enum DotsLoaderVariation {
  Typing = 'TYPING',
  Section = 'SECTION',
}
